document.addEventListener("DOMContentLoaded", () => {
async function shopify_api(url){
  if(window.location.pathname == '/products/find-your-mobile-device-here'){
    url = 'find-your-mobile-device-here';
  }
  const res = await fetch(url)
  const resJ = res.json()
  return resJ
}

async function variant_get(handle,variant){
  const {product} = await shopify_api(`/products/${handle}.json`)
  document.querySelector('.product-variant-id[name="id"]').value = ''
  let images = ''

  variant && product.variants.forEach((item,i) => {
    const image = product.images.filter(image => image.id == item.image_id)
    const alt = image[0]?.alt
    const variant_id = item.id;
    const variant_title = item.title;
    if(image[0]?.src !== undefined){
      images = images + `<div class="parent-skin-variant"><div class="skin-variant-image"> <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"/> </svg> <img class="product_variant_image img_btn ${i == 0 && 'selected'}" variant-id="${variant_id}" src="${image[0]?.src}&width=800" alt=${alt} price="${parseInt(item.price)}" price="${parseInt(item.price)}" compare_at_price="${item.compare_at_price}" title="${variant_title}" /> <h4 class="product_variant_title">${variant_title}</h4> </div> <div style="display:none;" class="skin-image-preview-popup"> <div class="close-button-skin-image-preview"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"/></svg> </div> <div class="selected-skin-image-preview"><img class="product_variant_image"  src="${image[0]?.src}&width=800" alt=${alt} loading="lazy" ></div> </div> </div> `
    }else{
      images = images + `<div class="visually-hidden"> </div>`;
    }
    i == 0 && ( document.querySelector('.product-variant-id[name="id"]').value = variant_id )
  })

  !variant && product.images.forEach((item,i) => {
    const src = item.src
    const alt = item?.alt || 'Skin' ;
    images = images + `<div class="parent-skin-variant"><div class="skin-variant-image"> <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"/> </svg> <img class="product_variant_image" src="${src}&width=800" alt="${alt}"/> <h4 class="product_variant_title">${alt}</h4></div> <div style="display:none;" class="skin-image-preview-popup"> <div class="close-button-skin-image-preview"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"/></svg> </div> <div class="selected-skin-image-preview"><img class="product_variant_image" loading="lazy" src="${src}&width=800" alt="${alt}"></div> </div> </div> `
  })
  // model_unslider()
  document.querySelector('.variant-images-to-show').innerHTML = images
  document.querySelector('.variant-images-to-show').innerHTML = images
  document.querySelector('.product_variant_image.img_btn.selected')?.click()
  // model_slider()
  attachEventListeners()
}

const select_custom_brand = document.querySelector('.select_custom_brand')
const select_custom_model = document.querySelector('#select_custom_model')
const product_variant_image = document.querySelector('.custom-variant-option .variant-images-to-show')

  // select_custom_brand.addEventListener('click',() => {
  //   select_custom_brand.classList.remove('blink');
  // })

  // select_custom_model.addEventListener('click',() => {
  //   select_custom_model.classList.remove('blink');
  // })
  
async function handleBrandChange(brand) {
  const specialNote = document.querySelector(".special_note");
  if (specialNote) {
    specialNote.style.display = brand === "motorola" ? "block" : "none";
  }

  const brandOption = select_custom_brand.querySelector(`option[value=${brand}]`);
  const handle = brandOption.getAttribute('handle');
  let data_models = brandOption.getAttribute('data-models');
  if(window.location.pathname != '/products/find-your-mobile-device-here'){
    data_models = data_models.split('&&');
  }

  let options = '';
  if(window.location.pathname != '/products/find-your-mobile-device-here'){
    data_models.forEach((item, i) => {
      const ops = item.split(',');
      console.log(ops)
      if (i === 0) {
        options += `<option value="-1" disabled selected>Select Model</option>`;
      }
      options += `<option value="${ops[1].trim()}" handle="${ops[1].trim()}">${ops[0].trim()}</option>`;
    });
  }
  if(window.location.pathname == '/products/find-your-mobile-device-here'){
    data_models = data_models.split(',');
    data_models.forEach((item, i) => {
      const modelName = item.trim();
      if (i === 0) {
        options += `<option value="-1" disabled selected>Select Model</option>`;
      }
      if (modelName !== '') {
        options += `<option value="${brand}" handle="${modelName}">${modelName}</option>`;
      }
    });
    document.querySelector('[name="properties[Brand]"]').value = brand;
  }
  select_custom_model.innerHTML = options;

  const media = await shopify_api(`/products/${handle}?sections=main-product`);
  const section = media['main-product'];
  const element = new DOMParser().parseFromString(section, 'text/html');
  const media_gallery = element.querySelector('media-gallery').innerHTML;
  document.querySelector('media-gallery').innerHTML = media_gallery;

  variant_get(handle, false);
}

select_custom_brand.addEventListener('change', function () {
  const brand = this.value;
  handleBrandChange(brand);
});

if(window.location.pathname != '/products/find-your-mobile-device-here'){
  var SkinBrand = new URLSearchParams(window.location.search).get("skin-brand");
  if(SkinBrand != null){
      select_custom_brand.value = SkinBrand;
      handleBrandChange(`${SkinBrand}`);   
  }
}

select_custom_model.addEventListener('change',async function(){
  const brand = this.value;
  console.log(brand, this)
  const handle = this.querySelector(`option[value=${brand}]`).getAttribute('handle');
  const section_id = document.querySelector('product-info').closest('section').getAttribute('id').replace('shopify-section-','')
  if(window.location.pathname == '/products/find-your-mobile-device-here'){
    document.querySelector('[name="properties[Model]"]').value = select_custom_model.selectedOptions[0].textContent;
  }
  const media = await shopify_api(`/products/${handle}?view=new-main-product&sections=${section_id}`)

  
  const section = media[section_id]
  const element = new DOMParser().parseFromString(section, 'text/html');
  const media_gallery = element.querySelector('media-gallery').innerHTML
  const product_form = element.querySelector('product-form')?.innerHTML
  document.querySelector('media-gallery').innerHTML = media_gallery;

  const title = element.querySelector('.product__title').innerHTML;
  const dd = document.querySelectorAll('.product__title');
  document.querySelector('.product__title').innerHTML = title;
  const d_none_price = document?.querySelector('.d-none-price');
  if(d_none_price) d_none_price.style.display = "block";
  document.querySelector('.product__title h3').style.color = "#7b7b7b";
  document.querySelector('.product__title h3').style.fontSize = "12px";
  document.querySelector('.product__title h3').style.lineHeight = "12px";
  document.querySelector('.d-none-mrp').style.display = "block";
  variant_get(handle,true);
})
const sticky_buy_buttons = document.querySelector('.sticky-buy-buttons')
  const variant__title_buy= document.querySelector('.product-details .variant__title_buy')
  if(variant__title_buy){
    if(variant__title_buy.innerText===""){
      sticky_buy_buttons.style.display="none"
    }
  }
product_variant_image?.addEventListener('click',function(e){
  const target = e.target;
  const button = target.closest('.product_variant_image.img_btn');
  if(target.closest('.product_variant_image')){
    const selectedImage = target.closest('.product_variant_image');
    const src = target.closest('.product_variant_image').getAttribute('src').split('?')[0]
    document.querySelector('modal-opener .product__media img').setAttribute('srcset',src);
    document.querySelector('product-modal .product-media-modal__content img').setAttribute('srcset',src);
    
    document.querySelectorAll('.product_variant_image').forEach(image => image.classList.remove('selected'));
    document.querySelectorAll('.skin-variant-image').forEach(parent => parent.classList.remove('selected'));
    
    selectedImage.classList.add('selected');
    const selectedSkinVariant = selectedImage.closest('.skin-variant-image');
    selectedSkinVariant?.classList.add('selected');

    const variantTitle = selectedSkinVariant?.querySelector('.product_variant_title')?.innerText || '';
    const variantPrice = selectedImage?.getAttribute('price') || '';
    document.querySelector('.variant__title_buy') ? document.querySelector('.variant__title_buy').innerText = variantTitle : '';
    document.querySelector('.sticky-buy-buttons .price__container .price-item--regular .money') ? document.querySelector('.sticky-buy-buttons .price__container .price-item--regular .money').innerText = `₹ ${variantPrice}` : '';
     sticky_buy_buttons.style.display="flex"

     // const closePreviewSkin = document.querySelectorAll('.close-button-skin-image-preview');
     // const openPreviewSkin = document.querySelectorAll('#zoom-icon-cst-skin');
    if(window.location.pathname == '/products/find-your-mobile-device-here'){
     // const getSkin = document.querySelector('.product_variant_image.selected')?.getAttribute('skin_title') || document.querySelectorAll('.product_variant_image')[0].getAttribute('skin_title');
      document.querySelector('[name="properties[Find My Device]"]').value = variantTitle;
    }
  }
  if(target.closest('.product_variant_image.img_btn')){
    const id = target.getAttribute(`variant-id`)
    document.querySelector('.product-variant-id[name="id"]').value = id
    document.querySelectorAll('.product_variant_image').forEach(function(image){
      image.classList.remove('selected')
    })
    target.classList.add('selected')
 
    const price = button.getAttribute('price');
    console.log(price,"price")
    const get_price = target.closest('.product__column-sticky').querySelector('product-info span.price-item.price-item--sale').innerText;
    const currencySymbol = get_price.match(/[^0-9.,]+/)?.[0] || ''; // Extract currency symbol
    const priceWithoutDecimal = Math.floor(parseFloat(price)); // Remove decimals
    const formattedPrice = currencySymbol + priceWithoutDecimal; // Combine with symbol
    document.querySelector('product-info span.price-item.price-item--sale').innerHTML = formattedPrice;
    // document.querySelector('product-info span.price-item.price-item--sale').innerHTML = get_price.replace(/[0-9]./g, '') + price;
    console.log(formattedPrice,"gp")
    let compare_price = button.getAttribute('compare_at_price');
    const get_compare = target.closest('.product__column-sticky').querySelector('.product__info-container .price--on-sale .price-item--regular span.money')?.innerText;
    if(compare_price != null && compare_price != ''){
      compare_price = '₹ ' + compare_price;
    }
    document.querySelector('.product__info-container .price--on-sale .price-item--regular span.money').innerHTML = compare_price;
  }
});

 function attachEventListeners() {
  document.body.addEventListener('click', function (event) {
    if (event.target.matches('#zoom-icon-cst-skin')) {
      const parentContainer = event.target.closest('.parent-skin-variant');
      const previewPopup = parentContainer ? parentContainer.querySelector('.skin-image-preview-popup') : null;
      if (previewPopup) previewPopup.style.display = 'block';
    }

    if (event.target.matches('.close-button-skin-image-preview')) {
      const previewPopup = event.target.closest('.skin-image-preview-popup');
      if (previewPopup) previewPopup.style.display = 'none';
    }

    if (event.target.closest('.skin-image-preview-popup')) {
      const popup = event.target.closest('.skin-image-preview-popup');
      const selectedPreview = popup.querySelector('.selected-skin-image-preview');
      if (!selectedPreview.contains(event.target)) {
        popup.style.display = 'none';
      }
    }
  });
}

attachEventListeners();



// model_slider()
// function model_slider(){
//   $('.variant-images-to-show').slick({
//    rows: 2,
//   dots: false,
//   arrows: true,
//   infinite: true, 
//   speed: 500,
//   slidesToShow: 5,
//   slidesToScroll: 4,
//   draggable: true,
//   swipeToSlide: true,
//   prevArrow: '<span class="slide-arrow prev-arrow"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.70498 1.41L6.29498 0L0.294983 6L6.29498 12L7.70498 10.59L3.12498 6L7.70498 1.41Z" fill="#0C1C33"/> </svg></span>',
//   nextArrow: '<span class="slide-arrow next-arrow"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.705 0L0.294998 1.41L4.875 6L0.294998 10.59L1.705 12L7.705 6L1.705 0Z" fill="#0C1C33"/> </svg></span>',
//   responsive: [
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow: 4,
//         slidesToScroll: 3
//       }
//     },
//     {
//       breakpoint: 450,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 2
//       }
//     }
//   ]
// });
// }
// function model_unslider(){
//   $('.variant-images-to-show').slick('unslick');
// }
  });